import React, { Component, Fragment } from 'react'
import { Button, Tabs, Tab, IconButton, Tooltip, withStyles } from '@material-ui/core'
import HelpIcon from '@material-ui/icons/Help'
import { connect } from 'react-redux'
import moment from 'moment'

// actions
import {
  getWeedmapAccount,
  deleteWeedmapAccount,
  createWeedmapAccount,
  updateWeedmapPin,
  syncWeedmapMenu,
  resetSyncWeedmapMenu,
  updateWeedmapAccount,
  resetAndDeleteWeedmap,
  generateToken,
  renewToken,
  getWeedmapTags,
  updateWeedmapMapping,
  discontinueWeedmapsItems,
} from '../../../actions/integration'
import {
  getCategories,
  loadProducts,
  setProducts,
  bulkupdateProducts,
} from '../../../actions/inventory'

// local components
import WeedmapPinContainer from '../../../components/WeedmapInfo/WeedmapPinContainer'
import WeedMapMenuContainer from '../../../components/WeedmapInfo/WeedMapMenuContainer'
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import ModalDialog from '../../../components/common/ModalDialog'

import { partial } from '../../../utils/common'
import { hasAccess } from '../../../utils/api'
import { openErrorMessage, openSuccessMessage } from '../../../actions/message'
import { getCompanyFeatures, getRegions } from '../../../actions/company'
import qs from 'querystring'
import {
  getThirdPartyProducts,
  getThirdPartyBrands,
  categoryMappingVersion2,
  getMenuApiBrands,
  getMenuApiProducts,
} from '../../../actions/thirdParty'
import { Appcues } from '../../../utils/constants'
import { getObject, saveObject, removeObject } from '../../../utils/api'
import WeedMapMenuContainerV3 from '../../../components/WeedmapInfo/WeedMapMenuContainerV3'

const HelpTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#1cc4e8',
    color: '#fff',
    fontSize: theme.typography.pxToRem(13),
    maxWidth: 380,
  },
}))(Tooltip)

class Weedmaps extends Component {
  constructor(props) {
    super(props)
    // const { code = '' } = qs.parse(props.location.search.substr(1));
    this.state = {
      // activeTab: code ? 2 : 1,
      activeTab: 3,
      lastModified: null,
      code: false,
      term: '',
      category: '',
      categoryLastModified: null,
      weedmapsOrders: {},
    }
  }

  componentDidMount() {
    this.props.dispatch(getCompanyFeatures()).then((res) => {
      this.setState({
        weedmapsOrders: res ? res.weedmapsOrders : {},
      })
    })
    this.props.dispatch(getRegions())
    this.fetchWeedmapAccount()
    this.setState({ categoryLastModified: null })
    this.props.dispatch(getCategories()).then((res) => {
      this.setState({
        categoryLastModified: new Date().getTime(),
      })
    })
    this.props.dispatch(getWeedmapTags())
    //this.props.dispatch(loadBrands({start:0, limit: 0}));

    const { code = '' } = qs.parse(this.props.location.search.substr(1))
    if (code) {
      let data = { code, apiKeyIndex: 0 }
      let apiKeyIndex = getObject('wmApiKeyIndex')
      if (apiKeyIndex) {
        removeObject('wmApiKeyIndex')
        data = { ...data, apiKeyIndex }
      }

      this.props.dispatch(generateToken(data)).then((res) => {
        this.props.history.replace(`${this.props.location.pathname}`)
        this.props.dispatch(getWeedmapAccount()).then((res) => {
          this.setState({
            lastModified: new Date().getTime(),
          })
          this.handleTabChange(null, res.version == 'V3' ? 3 : 2)
        })
      })

      this.setState({
        code: !!code,
      })
    }
    //const values = qs.parse(this.props.location.search);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.integrationReducer.lastModified != this.props.integrationReducer.lastModified) {
      // eslint-disable-line
      this.setState({
        lastModified: nextProps.integrationReducer.lastModified,
      })
    }
  }

  fetchWeedmapAccount = () => {
    this.props.dispatch(getWeedmapAccount()).then((res) => {
      if (res && res.version) {
        this.setState({
          activeTab: res.version == 'V3' ? 3 : res.version == 'V2' ? 2 : 1,
          lastModified: new Date().getTime(),
          code: false,
        })
      }
      return res
    })
    return null
  }

  onSave = (data, afterOnSave) => {
    const { activeTab = 1 } = this.state

    const { weedmapAccount = {} } = this.props.integrationReducer

    if (activeTab == 1) {
      // eslint-disable-line
      const filteredWeedCategories = data.filter((menu) => menu.categoryId && menu.weedmapCategory)

      this.props
        .dispatch(
          updateWeedmapAccount({
            ...weedmapAccount,
            categoryMapping: [...filteredWeedCategories],
          }),
        )
        .then((response) => {
          afterOnSave && afterOnSave(response)
          this.fetchWeedmapAccount()
        })
    } else {
      this.props.dispatch(updateWeedmapMapping(data)).then((response) => {
        afterOnSave && afterOnSave(response)
        this.fetchWeedmapAccount()
      })
    }
  }

  updateWeedmapMapping = (data) => {
    this.props.dispatch(updateWeedmapMapping(data)).then((res) => {
      this.fetchWeedmapAccount()
    })
  }

  onPinUpdate = (data, afterOnSave = () => {}) => {
    const { weedmapAccount = {} } = this.props.integrationReducer

    const newWeedmapAccount = {
      ...weedmapAccount,
      apiKeyList: [...data],
    }

    this.props.dispatch(updateWeedmapPin(newWeedmapAccount)).then((response) => {
      this.fetchWeedmapAccount()
      afterOnSave(response)
    })
  }

  renderSyncMessage = (menuLastSyncDate) => {
    return (
      <i>
        {menuLastSyncDate !== null && menuLastSyncDate > 0
          ? `WM menu last synced at ${moment(menuLastSyncDate).format('hh:mmA')} PST ${moment(
              menuLastSyncDate,
            ).format('MM/DD/YYYY')}`
          : "WM menus has not been sync'ed"}
      </i>
    )
  }

  fetchWeedMap = (apiToHit = Promise.resolve({})) => {
    this.props.dispatch(apiToHit()).then((response) => this.fetchWeedmapAccount())
  }

  syncMenu = partial(this.fetchWeedMap, syncWeedmapMenu)
  resetSync = partial(this.fetchWeedMap, resetSyncWeedmapMenu)
  createWeedmap = partial(this.fetchWeedMap, () => createWeedmapAccount({ version: `V3` }))
  deleteWeedmap = partial(this.fetchWeedMap, deleteWeedmapAccount)
  resetDelete = partial(this.fetchWeedMap, resetAndDeleteWeedmap)

  onError = (msg) => this.props.dispatch(openErrorMessage(msg))

  openDeleteModal = () => {
    Appcues.track('Deleting Weedmaps Account')
    this.deleteModal.handleClickOpen()
  }

  onAccountDelete = () => {
    Appcues.track('Weedmaps Account Deleted')
    this.deleteModal.handleClose()
    this.deleteWeedmap()
    this.setState({
      activeTab: 3,
    })
  }

  openDeleteConfirmationModal = () => {
    this.resetDelete()
  }

  handleTabChange = (event, tab) => {
    const { categories = {} } = this.props.inventoryReducer
    this.setState({
      activeTab: tab,
      lastModified: new Date().getTime(),
      code: false,
    })
    if (tab == 2 || tab == 3) {
      // eslint-disable-line
      const filteredCategories =
        (categories.values && categories.values.filter((cat) => cat.active)) || []
      this.props.dispatch(
        loadProducts({
          categoryId: (filteredCategories[0] && filteredCategories[0].id) || '',
          weedmaps: true,
        }),
      )
      if (tab == 2) {
        this.props.dispatch(getWeedmapTags())
      }
    }
  }

  renewWeedmapToken = (index) => (tokenType) => {
    const data = { apiKeyIndex: index, tokenType }
    Appcues.track('Renewing Weedmaps Token')
    this.props.dispatch(renewToken(data)).then((res) => {
      window.location.href = `/settings/integration/weedmaps`
    })
  }

  authorizeWeedmapToken = (index) => () => {
    Appcues.track('Authorizing weedmap Token')
    saveObject('wmApiKeyIndex', index)
    window.location.href = `https://weedmaps.com/oauth/authorize?client_id=813b4161a26400bc6bc329ebb5671dc68bbce5eea3f5cbe8033d4d441896aa5d&redirect_uri=${window.location.protocol}//${window.location.host}/settings/integration/weedmaps&response_type=code&scope=menu_items`
  }

  getWeedmapProducts = (productId, brandId) => {
    this.props.dispatch(getThirdPartyProducts(brandId))
  }

  getBLAZEProducts = (categoryId) => {
    this.props.dispatch(setProducts({}))
    this.props.dispatch(loadProducts({ categoryId, weedmaps: true }))
  }

  showError = (message) => {
    this.props.dispatch(openErrorMessage(message))
  }

  performCategoryMapping = (mappingList, afterSave) => {
    this.props.dispatch(categoryMappingVersion2(mappingList)).then((res) => {
      this.props.dispatch(getCategories()).then((res) => {
        this.setState({
          categoryLastModified: new Date().getTime(),
        })
      })
      this.fetchWeedmapAccount()
      afterSave && afterSave()
    })
  }

  discontinueWMItems = (data, afterSave) => {
    this.props.dispatch(discontinueWeedmapsItems(data)).then((res) => {
      afterSave && afterSave()
    })
  }

  getWmMenuApiProducts = (term, brandId, brandName, start, limit) => {
    return this.props.dispatch(getMenuApiProducts(term, brandId, brandName, start, limit))
  }

  getWmMenuApiBrands = (term = '') => {
    return this.props.dispatch(getMenuApiBrands({ term }))
  }

  getThirdPartyBrands = (term = '') => {
    return this.props.dispatch(getThirdPartyBrands({ term }))
  }

  getThirdPartyProducts = (brandId = '') => {
    return this.props.dispatch(getThirdPartyProducts({ brandId }))
  }

  enableWeedmapforProducts = (productIds, afterBulkUpdate) => {
    this.props
      .dispatch(
        bulkupdateProducts({ operationType: 'WEEDMAP_STATUS', enableWeedmap: true, productIds }),
      )
      .then((res) => {
        afterBulkUpdate && afterBulkUpdate()
        this.props.dispatch(openSuccessMessage('Products mapped succesfully!'))
      })
      .catch((err) => {
        console.log(err)
      })
  }

  disableWeedmapforProducts = (productIds, afterDisableWeedmap) => {
    this.props
      .dispatch(
        bulkupdateProducts({ operationType: 'WEEDMAP_STATUS', enableWeedmap: false, productIds }),
      )
      .then((res) => {
        afterDisableWeedmap && afterDisableWeedmap()
        this.props.dispatch(openSuccessMessage('Product deleted succesfully!'))
      })
      .catch((err) => {
        console.log(err)
      })
  }

  onChangeSearchTerm = (e) => {
    this.setState({
      term: e.target.value,
    })
  }

  onSearch = () => {
    const { term = '' } = this.state
    const { categories = {} } = this.props.inventoryReducer
    let filtered = categories && categories.values.filter((cat) => cat.active)
    if (term != '') {
      // eslint-disable-line
      this.props
        .dispatch(
          loadProducts({
            term,
            categoryId: this.state.category || (filtered && filtered[0].id),
            weedmaps: true,
          }),
        )
        .then((res) => {
          this.setState({
            lastModified: new Date().getTime(),
          })
        })
    } else {
      this.props
        .dispatch(
          loadProducts({
            categoryId: this.state.category || (filtered && filtered[0].id),
            weedmaps: true,
          }),
        )
        .then((res) => {
          this.setState({
            lastModified: new Date().getTime(),
          })
        })
    }
  }

  updateCategory = (category) => {
    this.setState({ category })
  }

  render() {
    const {
      activeTab = 3,
      lastModified = null,
      categoryLastModified = null,
      weedmapsOrders = {},
    } = this.state
    const { thirdPartyProducts = [], thirdPartyBrands = [] } = this.props.thirdPartyReducer
    const { weedmapAccount = {}, weedmapTags = [] } = this.props.integrationReducer
    const { categories = {}, products = {}, brands = {} } = this.props.inventoryReducer

    const { regions = {} } = this.props.companyReducer

    const {
      apiKeyList = [],
      menuLastSyncDate,
      categoryMapping = [],
      defaultTagMapping = {},
      tagMapping = [],
    } = weedmapAccount

    const categoriesValues = categories.values || []
    const productsValues = products.values || []
    const brandsValues = brands.values || []

    const permitted = hasAccess()

    return (
      <div>
        <Tabs
          value={activeTab}
          onChange={this.handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          centered
          className="margin-bottom-small"
        >
          <Tab
            style={{ display: weedmapAccount.version == 'V2' ? 'inline-flex' : 'none' }}
            label="Version 2"
            value={2}
          />
          <Tab
            style={{ display: weedmapAccount.version != 'V2' ? 'inline-flex' : 'none' }}
            label="Version 3"
            value={3}
          />
        </Tabs>
        {weedmapAccount.id && categories.values != undefined ? (
          <Fragment>
            {permitted ? (
              <div className="pull-right margin-bottom-medium">
                <Button className="danger-button margin" onClick={this.openDeleteModal}>
                  Delete weedmaps account
                </Button>
                {activeTab === 2 ? (
                  <HelpTooltip
                    title="Need to delete your WM account? Contact support to reactivate V2 after deleting your account at support@blaze.me"
                    placement="top-start"
                  >
                    <IconButton className="iconButtonHelp">
                      <HelpIcon className="helpInfo" />
                    </IconButton>
                  </HelpTooltip>
                ) : null}
              </div>
            ) : null}
            <WeedmapPinContainer
              apiKeyList={apiKeyList}
              lastModified={lastModified}
              onPinUpdate={this.onPinUpdate}
              onError={this.onError}
              regions={(regions && regions.values) || []}
              permitted={permitted}
              version={activeTab}
              authorizeWeedmapToken={this.authorizeWeedmapToken}
              renewWeedmapToken={this.renewWeedmapToken}
              weedmapsOrders={weedmapsOrders}
            />
            <div className="margin-top-medium margin-bottom-medium center-aligned-child">
              {activeTab != 3 ? this.renderSyncMessage(menuLastSyncDate) : null}
            </div>
            {activeTab == 3 ? (
              <WeedMapMenuContainerV3
                lastModified={lastModified}
                categoryLastModified={categoryLastModified}
                categoryMapping={categoryMapping}
                categoryList={categoriesValues}
                onSave={this.onSave}
                onError={this.onError}
                permitted={permitted}
                defaultTagMapping={defaultTagMapping}
                tagMapping={tagMapping}
                productsList={productsValues}
                brandsList={brandsValues}
                weedmapTags={weedmapTags}
                getBLAZEProducts={this.getBLAZEProducts}
                showError={this.showError}
                performCategoryMapping={this.performCategoryMapping}
                enableWeedmapforProducts={this.enableWeedmapforProducts}
                disableWeedmapforProducts={this.disableWeedmapforProducts}
                onChangeSearchTerm={this.onChangeSearchTerm}
                onSearch={this.onSearch}
                updateCategory={this.updateCategory}
                getThirdPartyProducts={this.getThirdPartyProducts}
                updateWeedmapMapping={this.updateWeedmapMapping}
                thirdPartyProducts={thirdPartyProducts}
                thirdPartyBrands={thirdPartyBrands}
                getWmMenuApiProducts={this.getWmMenuApiProducts}
                getWmMenuApiBrands={this.getWmMenuApiBrands}
                discontinueWeedmapsItems={this.discontinueWMItems}
              />
            ) : (
              <WeedMapMenuContainer
                lastModified={lastModified}
                categoryLastModified={categoryLastModified}
                syncMenu={this.syncMenu}
                resetSync={this.resetSync}
                categoryMapping={categoryMapping}
                categoryList={categoriesValues}
                onSave={this.onSave}
                onError={this.onError}
                resetDelete={this.openDeleteConfirmationModal}
                permitted={permitted}
                version={activeTab}
                defaultTagMapping={defaultTagMapping}
                tagMapping={tagMapping}
                productsList={productsValues}
                brandsList={brandsValues}
                weedmapTags={weedmapTags}
                getWeedmapProducts={this.getWeedmapProducts}
                thirdPartyProducts={thirdPartyProducts}
                getBLAZEProducts={this.getBLAZEProducts}
                showError={this.showError}
                getThirdPartyBrands={this.getThirdPartyBrands}
                thirdPartyBrands={thirdPartyBrands}
                performCategoryMapping={this.performCategoryMapping}
                enableWeedmapforProducts={this.enableWeedmapforProducts}
                disableWeedmapforProducts={this.disableWeedmapforProducts}
                onChangeSearchTerm={this.onChangeSearchTerm}
                onSearch={this.onSearch}
                updateCategory={this.updateCategory}
                getThirdPartyProducts={this.getThirdPartyProducts}
                updateWeedmapMapping={this.updateWeedmapMapping}
                discontinueWeedmapsItems={this.discontinueWMItems}
              />
            )}
            <ModalDialog
              ref={(c) => (this.deleteModal = c)}
              onConfirm={this.onAccountDelete}
              confirmText="delete"
            >
              Are you sure you want to delete WM account?
            </ModalDialog>
          </Fragment>
        ) : (
          <div className="center-aligned-child">
            <Button className="primary-button margin" onClick={this.createWeedmap}>
              Add Weedmaps Account
            </Button>
          </div>
        )}
      </div>
    )
  }
}

const WeedmapWithTitle = ContainerWithTitle(Weedmaps, 'Weedmaps Settings')
const WeedmapInfoConnected = connect(
  ({ dispatch, integrationReducer, inventoryReducer, companyReducer, thirdPartyReducer }) => ({
    dispatch,
    integrationReducer,
    inventoryReducer,
    companyReducer,
    thirdPartyReducer,
  }),
)(WeedmapWithTitle)

export default WeedmapInfoConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Integration/Weedmaps.js